export default "__VITE_ASSET__Dns8Ml71__"